import React, { useState, useMemo } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { Menu as MenuIcon } from "react-feather";
import { useMsal } from "@azure/msal-react";

import { useTypedSelector } from "../../store/models/root.interface";
import { Settings } from "../../api";

import NavMenu from "../../common/components/NavMenu";
import Routes from "./Routes";

import Notifications from "../../components/Account/Notifications";
import Profile from "../../components/Account/UserProfile";
import SurveyModal from "../../components/Survey/SurveyModal";

const Layout = () => {

  const [isMenuOpen, setMenuOpen] = useState(false);
  const settingsState = useTypedSelector(state => state.root.settings);
  const showReports = useTypedSelector(state => !!state.reports.reports?.length);
  const subscriptions = useTypedSelector(state => !!state.subscriptions.items && typeof state.subscriptions.items !== "string"
    ? state.subscriptions.items : []);

  const { instance } = useMsal();
  const [account] = useState(() => instance.getActiveAccount());
  const [partnerName] = useState(process.env.REACT_APP_PARTNER_NAME ?? (account?.idTokenClaims as any)?.partnerName ?? "");

  const settings: Settings = useMemo(
    () => !settingsState || typeof settingsState === "string" ? {} : settingsState,
    [settingsState]);

  return (
    <>
      <div className="d-flex flex-column vh-100">
        <div className="d-flex flex-column flex-md-row">
          {/* Logo */}
          <div className="c-left-bar d-flex justify-content-end bg-secondary">
            <Link
              to="/"
              className="flex-md-grow-1 d-flex align-items-center justify-content-center px-3 px-md-4 py-1"
            >
              <img
                className="c-site-logo"
                src="/img/omnicore-neg-RGB.svg"
                alt="Omnicore logo"
              />
            </Link>
          </div>
          {/* Profile bar */}
          <div
            className="flex-grow-1 d-flex bg-secondary border-bottom box-shadow"
            style={{ zIndex: 1 }}
          >
            {/* Menu toggle (< md) */}
            <div className="d-flex d-md-none">
              <a
                href="#0"
                className="d-flex align-items-center text-secondary p-2"
                onClick={(e) => {
                  e.preventDefault();
                  setMenuOpen(!isMenuOpen);
                }}
              >
                <MenuIcon />
              </a>
            </div>
            {/* Partner branding */}
            <div className="flex-grow-1 d-flex align-items-center justify-content-end px-2 py-1">
              {!!settings.logoUrl
                ? (
                  <img
                    style={{ height: 32 }}
                    src={settings.logoUrl}
                    alt={partnerName}
                  />)
                : (<div className="text-uppercase text-primary fw-6">{partnerName}</div>)}
            </div>
            <div className="c-profile d-flex position-relative">
              {/* Notifications */}
              <div className="d-flex border-left">
                <Notifications />
              </div>
              {/* Profile */}
              <div className="flex-grow-1 d-flex position-relative">
                <div className="flex-grow-1 d-flex border-left">
                  <Profile />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 mh-0 d-flex">
          {/* Main menu - left */}
          <div
            className={classnames({
              "c-navbar": true,
              "c-navbar--open": isMenuOpen,
              "bg-secondary": true,
            })}
          >
            <div className="flex-grow-1 mh-0 d-flex flex-column">
              {/* Main menu */}
              <div className="c-navbar__menu flex-grow-1 scroll-auto custom-scrollbar-hidden">
                <NavMenu showMarketing={settings.showMarketing} />
              </div>
            </div>
          </div>
          <div className="flex-grow-1 d-flex flex-column">
            {/* Content areas */}
            <div className="flex-grow-1 d-flex mh-0">
              <Routes
                showMarketing={settings.showMarketing}
                showReports={showReports}
                subscriptions={subscriptions} />
            </div>
          </div>
        </div>
      </div>
      <SurveyModal />
    </>
  );
};

export default Layout;
